import { HeaderLogo } from './header-logo';
import { HeaderLinks } from './header-links';
import classNames from './index.module.css';
import type { PropsWithChildren, ReactNode } from 'react';

/**
 * HomeLayout is unique as it does not use AppShell like every other page, and instead has a custom header and layout.
 * This is because the home page has a unique design that does not fit the AppShell layout.
 */
export function HomeLayout(props: PropsWithChildren): ReactNode {
  return (
    <div className={classNames.root} data-is-home="true">
      <header className={classNames.header} data-is-home="true">
        <HeaderLogo isHome={true} />
        <HeaderLinks linkColor="var(--vespa-color-rock)" />
      </header>
      <main className={classNames.main}>{props.children}</main>
    </div>
  );
}
